import React, { Component } from 'react';
import youtube from '../../../assets/youtube.png';
import PropTypes from 'prop-types';

class Youtube extends Component {
    constructor(props) {
        super(props);

        this.state = {
            status: ''
        };
        
        this.token = this.props.token;
    }

    componentDidMount() {
        const { username } = this.props.user.user;
        this.getYTStatus(username, this.token);
    }

    getYTStatus(user, token) {
        this.props.api.youtube.getUser({
            user,
            token,
        })
            .then(response => {
                this.setState({ status: response.status });
            })
            .catch(err => {
                console.error(err);
                this.setState({ status: 'error' });
            });
    }

    onErrorClick = () => {
      const { username } = this.props.user.user;

      this.getYTStatus(username, this.token);
    };

    connectYoutube = () => {
        const { username } = this.props.user.user;
    
        this.props.api.youtube.postUser({
            user: username,
            token: this.token
        })
            .then(async (response) => {
                let json = await response.json();
                window.location.assign(json.authUrl);
            })
            .catch(err => {
                console.error(err);
                this.setState({ status: 'error' });
            });

        return false;
    };

    disconnectYoutube = () => {
        const { username } = this.props.user.user;
    
        this.props.api.youtube.deleteUser({
            user: username,
            token: this.token
        })
            .then(() => {
                this.getYTStatus(username, this.token);
            })
            .catch(err => {
                console.error(err);
                this.setState({ status: 'error' });
            });
    };

    renderPod = () => {
        const { status } = this.state;
        
        if (status === 'error') {
            return (
                <div>
                    <p>An error was encountered</p>
                    <button className="btn btn-black" onClick={this.onErrorClick}>Retry</button>
                </div>
            )
        } else if (status > 299) {
            return (
                <div className="form">
                    <p className="p-info">
                        Broadcast simultaneously on Youtube, when you go
                        live on Naked News. Please enter your Youtube
                        credentials below to get started.{' '}
                    </p>
            
                    <div className="sec">
                        <button
                            className="btn btn-black"
                            onClick={this.connectYoutube}
                        >
                            Authorize
                        </button>
                    </div>
                </div>
            );
        } else if (status > 199 && status < 300) {
            return (
                <div>
                    <p>You are connected to Youtube.</p>
                    <button
                        className="btn btn-black"
                        onClick={this.disconnectYoutube}
                    >
                        Disconnect
                    </button>
                </div>
            );
        }
    };

    render() {
        return (
            <div>
                <div className="pod social">
                    <div className="icon">
                        <img src={youtube} alt="" />
                    </div>
                    <div className="pod-content">
                        <div className="title">Youtube</div>
                        {this.renderPod()}
                    </div>
                </div>
            </div>
        );
    }
}

Youtube.propTypes = {
    api: PropTypes.object.isRequired,
    token: PropTypes.string.isRequired,
    user: PropTypes.object.isRequired
};

export default Youtube;

